// extracted by mini-css-extract-plugin
module.exports = {"root":"Attachments_root__2AWU6"};